import React from 'react';
import { HomeIcon } from 'lucide-react';
import { trackMetaEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
};
export function CTAButton({
  label,
  size = 'md',
  fullWidth = false,
  href = '#precio'
}: CTAButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-6 py-3.5 text-sm sm:px-8 sm:py-4 sm:text-base' : 'px-5 py-3 text-[13px] sm:px-6 sm:py-3.5 sm:text-sm';
  const isExternal = href.startsWith('http');
  const handleClick = () => {
    trackMetaEvent(isExternal ? 'InitiateCheckout' : 'Lead', {
      content_name: 'Anfitrión Pro 365',
      content_ids: ['anfitrion-pro-365'],
      content_category: label,
      value: 19,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={['group inline-flex items-center justify-center gap-3 rounded-xl bg-brand font-extrabold tracking-tight text-white', 'shadow-price transition-[transform,background-color] duration-150 ease-out', 'hover:bg-brand-dark hover:-translate-y-0.5 active:translate-y-0', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand', sizeClasses, fullWidth ? 'w-full' : ''].join(' ')} data-id="element-39" data-mp="3cpkq1t7z8bq0">
      <HomeIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-40" data-mp="1s6zcdvxmbt63" />
      <span className="text-center uppercase" data-id="element-41" data-mp="1w8kmj9irptcl">{label}</span>
    </a>;
}